import {createApp} from 'vue'
import {createI18n} from 'vue-i18n'
import ArticlesApp from '@/components/ArticlesApp.vue'
import ToastPlugin from 'vue-toast-notification'
import {createPinia} from 'pinia'
import router from '@/router';

const i18n = createI18n({
  legacy: false,
  locale: settings.languageCode,
  fallbackLocale: 'en',
  messages: translation,
})

const app = createApp(ArticlesApp)
app.config.globalProperties.window = window;

app.use(createPinia());
app.use(router);
app.use(ToastPlugin)
app.use(i18n)
app.mount('#articles-app')
